<template>
  <div class="video-bg">
    <div :class="['video-wrap', mode == 'fullscreen' ? 'fullscreen' : '']">
      <video
        :src="src"
        @ended="onVideoEnd()"
        class="video"
        ref="video"
        autoplay
        muted
        playsinline
      ></video>
    </div>
    <slot name="content"></slot>
  </div>
</template>
<script>
export default {
  name: "video-bg",
  props: {
    bgColor: String,
    bgOpacity: Number,
    mode: String,
    src: String
  },
  methods: {
    onVideoEnd() {
      this.$emit("ended");
    },
    play() {
      this.$refs.video.play();
    }
  },
  watch: {
    $route() {
      //this.$refs.video.play();
    }
  }
};
</script>
<style lang="scss" scoped>
.video-wrap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;

  &.fullscreen {
    height: 100vh;
  }

  video {
    min-height: 100%;
    min-width: 100%;
  }

  .overlay-bg {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
  }
}

.video-bg {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
</style>
